import { ViolationStatus } from '../api/violations.model';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const ViolationStatusesSelectOptions: ISelectOption[] = [
  {
    id: `${FilterTypesEnum.ViolationStatus.toString()}-${ViolationStatus.open}`,
    value: ViolationStatus.open,
    displayName: ViolationStatus.open,
    filterType: FilterTypesEnum.ViolationStatus,
    categoryName: FilterTypesEnum.ViolationStatus.toString(),
  },
  {
    id: `${FilterTypesEnum.ViolationStatus.toString()}-${ViolationStatus.resolved}`,
    value: ViolationStatus.resolved,
    displayName: ViolationStatus.resolved,
    filterType: FilterTypesEnum.ViolationStatus,
    categoryName: FilterTypesEnum.ViolationStatus.toString(),
  },
  {
    id: `${FilterTypesEnum.ViolationStatus.toString()}-${ViolationStatus.exempted}`,
    value: ViolationStatus.exempted,
    displayName: ViolationStatus.exempted,
    filterType: FilterTypesEnum.ViolationStatus,
    categoryName: FilterTypesEnum.ViolationStatus.toString(),
  },
];
